import React, { Component } from 'react'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

class FavoriteActivityFooter extends Component {
  state = {
    showDescription: false,
  }
  render() {
    const { showDescription } = this.state
    const { t, quoteAuthor } = this.props
    return (
      <div className="favorite-activity-footer">
        <div className="favorite-activity-footer__content">
          <div className="favorite-activity-footer__author">- {quoteAuthor}</div>
          <div
            className={classNames('favorite-activity-footer__control', {
              'favorite-activity-footer__control--active': showDescription,
            })}
            onClick={() => this.setState({ showDescription: !showDescription })}
          >
            {t('Activity Description')}
            <div className="favorite-activity-footer__arrow" />
          </div>
        </div>
        {showDescription && this.props.children}
      </div>
    )
  }
}

FavoriteActivityFooter.displayName = 'FavoriteActivityFooter'

export default withTranslation('user')(FavoriteActivityFooter)
